import { Typography } from '@mui/material';
import { DefaultCard, PageLayout } from 'components';
import DropLetter from 'components/layout/dropLetter/DropLetter';
import React from 'react';
import TabbedSection from './tabbedSection/TabbedSection';

function GuidelinesPage() {
  return (
    <PageLayout>
      <DefaultCard title="GUIDELINES">
        <Typography variant="body1">
          <DropLetter letter="T" />
          he undergirding purpose of Harmony Hill is that we honor God in all
          that we think, say, and do. Because His ways are higher than our ways,
          we continue seeking to know His ways and to do them. He is our
          Heavenly Father… “it is He that hath made us and not we ourselves; we
          are His people and the sheep of His pasture.” Ps 100:3
        </Typography>
        <br />
        <Typography variant="body1">
          The purpose of all our guidelines is the security and well-being of
          our students and the preservation of the God-honoring atmosphere we
          always strive to uphold at Harmony Hill. Your assistance in achieving
          this purpose is sincerely appreciated.
        </Typography>
        <br />
        <Typography variant="body1">
          All guidelines should be read carefully before registering and are
          applicable from the beginning of camp preparation until the camp is
          closed.
        </Typography>
        <br />
        <Typography variant="body1">
          For the purposes of the policies and guidelines, Student is defined as
          an individual 17 years of age or younger. <strong>Guardian</strong> is
          defined as a 21 year old or older adult, <u>related to</u> the
          student, who assumes responsibility for that student's behavior at
          Harmony Hill Singing School.
        </Typography>
        <br />
        <br />
        <TabbedSection />
      </DefaultCard>
    </PageLayout>
  );
}

export default GuidelinesPage;
